angular.module('shared').factory('EnvironmentService', function() {
  var CwxEnvironment, rawEnv;
  CwxEnvironment = {
    Test: 'test',
    Development: 'development',
    Staging: 'staging',
    Uat: 'uat',
    Production: 'production'
  };
  rawEnv = window.cwxEnv;
  return {
    environment: rawEnv,
    isProductionEnv: function() {
      return rawEnv === CwxEnvironment.Production;
    }
  };
});
